import { SupportCasesItem } from '../../types';
import { callExternalApi } from '../callExternalApi';

export type CaseRequest = {
  Status: string;
  AccountId: string | undefined;
  ContactId: string | undefined;
  Description: string;
  Type: string;
  RecordTypeId: string;
  OutsideInventoryId: string;
  Reason: string;
  Priority: string;
  OrderProductId: string;
  AdditionalRecipients: string;
  supplierCaseNumber: string;
};

export async function postCase(requestBody: CaseRequest) {
  const url = 'api/cases';
  return await callExternalApi<SupportCasesItem[]>({
    url,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: requestBody
  });
}
